import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";

import { dashboardRefreshMiddleware } from "./middleware/dashboardRefreshMiddleware";
import persistConfig from "./persistConfig";
import rootReducer from "./reducers";

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }).prepend(dashboardRefreshMiddleware.middleware),
});

const persistor = persistStore(store);

export { persistor, store };
